import { CheckoutReturnType } from './../constants/checkout-return-type';
import { environment } from './../../../environments/environment';
import { of } from 'rxjs';
import { PagePath } from './../models/page-model';
import { ProductConfigurationIds } from '../models/cart-model';
import { ProductName } from './../constants/product-domain';
import { ConstantsService, QuestionnaireId } from './constants.service';
import { CrossSellPackages } from './../constants/cross-sell-packages';
import { ExpressOrderResponse } from '../models/express-order-model';
import { TagType } from '@legalzoom/tagging-sdk';
import * as i0 from "@angular/core";
import * as i1 from "../state/app/app.service";
import * as i2 from "@legalzoom/business-formation-sdk";
import * as i3 from "@legalzoom/order-sdk";
import * as i4 from "@legalzoom/payment-sdk";
import * as i5 from "@legalzoom/notification-sdk";
import * as i6 from "./questionnaire/questionnaire.service";
import * as i7 from "@legalzoom/processing-order-sdk";
import * as i8 from "./tracking/tracking.service";
import * as i9 from "./event.service";
import * as i10 from "@legalzoom/questionnaire-answer-sdk";
import * as i11 from "@legalzoom/tagging-sdk";
export class CrossSellService {
    constructor(appService, queueService, orderService, trackJS, paymentService, emailNotificationService, questionnaireService, processingOrderService, trackingService, eventService, questionnaireAnswerService, taggingService) {
        this.appService = appService;
        this.queueService = queueService;
        this.orderService = orderService;
        this.trackJS = trackJS;
        this.paymentService = paymentService;
        this.emailNotificationService = emailNotificationService;
        this.questionnaireService = questionnaireService;
        this.processingOrderService = processingOrderService;
        this.trackingService = trackingService;
        this.eventService = eventService;
        this.questionnaireAnswerService = questionnaireAnswerService;
        this.taggingService = taggingService;
        this.newSkuArray = [];
    }
    savePackage(selectedPackage) {
        if (selectedPackage === CrossSellPackages.tms || selectedPackage === CrossSellPackages.both) {
            this.loadQueueForCrossSellOrder(ProductConfigurationIds.tmsCrosssell);
        }
        if (selectedPackage === CrossSellPackages.lwt || selectedPackage === CrossSellPackages.both) {
            this.loadQueueForCrossSellOrder(ProductConfigurationIds.lwtCrosssell);
        }
        this.queueService.add(this.preprareSaveAndContinue());
        this.queueService.process().subscribe(() => { });
    }
    loadQueueForCrossSellOrder(crossSellConfigId) {
        this.queueService.add(this.prepareCreateCrossSellsOrder_CrossSell(crossSellConfigId));
        this.queueService.add([
            this.prepareCreateBillOrder_CrossSell(crossSellConfigId),
            this.prepareCreateProcessingOrderQueue(crossSellConfigId)
        ]);
        if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
            this.queueService.add(this.prepareUpdateQuestionnaireForTms());
            this.queueService.add(this.prepareUpdateProcessingOrderForTms());
        }
        if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
            this.queueService.add(this.prepareUpdateQuestionnaireForLWT());
        }
        this.queueService.add(this.prepareTagOrderById_CrossSell(crossSellConfigId));
        this.queueService.add([
            this.prepareCreateOrderContactPrimary(crossSellConfigId),
            this.prepareCreateOrderContactShipping(crossSellConfigId),
            this.prepareCreateOrderContactBilling(crossSellConfigId),
            this.prepareTrackCrosssellOrderItems()
        ]);
        this.queueService.add(this.prepareSendEmailNotification(crossSellConfigId));
    }
    prepareCreateCrossSellsOrder_CrossSell(crossSellConfigId) {
        const newOrder = true;
        return {
            name: 'prepareCreateCrossSellsOrder_CrossSell ' + this.constructor.name,
            pre: () => {
                const createCrossSellOrderRequest = {
                    productConfigurationId: crossSellConfigId,
                    createdBy: this.appService.customerId.toString()
                };
                return this.orderService.createCrossSellOrder(this.appService.orderId, createCrossSellOrderRequest, newOrder, this.appService.customerId);
            },
            post: response => {
                if (!environment.production) {
                    console.log('1. createCrossSellsOrder_CrossSell: productConfigId: ' +
                        crossSellConfigId +
                        ' | RESPONSE: Order Id: ' +
                        response.orderId +
                        ' processing order Id: ' +
                        response.orderItem.processingOrder.processingOrderId +
                        ' extended Price: ' +
                        response.orderItem.extendedPrice);
                    console.log('1. createCrossSellsOrder_CrossSell: getOrderContactResponse  ' +
                        response);
                }
                if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
                    this.appService.tmsCrossSellOrderResponse = response;
                    this.questionnaireService.llc.TMSExpressOrderResponse = new ExpressOrderResponse();
                    this.questionnaireService.llc.TMSExpressOrderResponse.ExpressOrderId = response.orderId;
                }
                else if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
                    this.appService.lwtCrossSellOrderResponse = response;
                    this.questionnaireService.llc.LWTExpressOrderResponse = new ExpressOrderResponse();
                    this.questionnaireService.llc.LWTExpressOrderResponse.ExpressOrderId = response.orderId;
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                this.appService.expressOrderProcessType = CheckoutReturnType.createCrossSellOrder;
                return of(null);
            }
        };
    }
    prepareCreateBillOrder_CrossSell(crossSellConfigId) {
        let crossSellOrder;
        return {
            name: 'prepareCreateBillOrder_CrossSell ' + this.constructor.name,
            pre: () => {
                if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
                    crossSellOrder = this.appService.tmsCrossSellOrderResponse;
                }
                else if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
                    crossSellOrder = this.appService.lwtCrossSellOrderResponse;
                }
                const createPaymentRequest = {
                    orderId: crossSellOrder.orderId,
                    amount: crossSellOrder.orderItem.extendedPrice.toFixed(2),
                    createdBy: this.appService.customerId.toString(),
                    comments: 'Cross Sell Order',
                    reasonId: '1',
                    paymentProfileId: this.appService.paymentProfileId,
                    gateway: this.appService.paymentGateway,
                    source: '100',
                    notificationEmail: this.appService.loginEmail,
                    transactionType: 'Charge'
                };
                return this.paymentService.createPayment(createPaymentRequest, this.appService.customerId);
            },
            post: response => {
                if (!environment.production) {
                    console.log('2. createBillOrder_CrossSell: crossSell_orderId: ' +
                        crossSellOrder.orderId +
                        ' | RESPONSE: order Id ' +
                        response.orderId +
                        '| transactionStatus: ' +
                        response.transactionStatus);
                }
                if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
                    this.appService.tmsCrossSellPaymentResponse = response;
                    this.questionnaireService.llc.TMSExpressOrderResponse.PaymentStatus = response.transactionStatus;
                }
                else if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
                    this.appService.lwtCrossSellPaymentResponse = response;
                    this.questionnaireService.llc.LWTExpressOrderResponse.PaymentStatus = response.transactionStatus;
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareCreateProcessingOrderQueue(crossSellConfigId) {
        return {
            name: 'prepareCreateProcessingOrderQueue ' + this.constructor.name,
            pre: () => {
                let crossSellOrder;
                if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
                    crossSellOrder = this.appService.tmsCrossSellOrderResponse;
                    return this.processingOrderService.createProcessingOrderQueue(crossSellOrder.orderItem.processingOrder.processingOrderId, crossSellOrder.orderItem.orderItemId, this.appService.app.customerId);
                }
                else if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
                    crossSellOrder = this.appService.lwtCrossSellOrderResponse;
                    return of(null);
                }
            },
            post: response => {
                if (response) {
                    this.appService.createProcessingOrderQueue = response;
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareSendEmailNotification(crossSellConfigId) {
        let crossSellOrder;
        return {
            name: 'prepareSendEmailNotification ' + this.constructor.name,
            clearQueueOnError: false,
            pre: () => {
                if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
                    crossSellOrder = this.appService.tmsCrossSellOrderResponse;
                }
                else if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
                    crossSellOrder = this.appService.lwtCrossSellOrderResponse;
                }
                const emailHandlerRequest = {
                    RequestType: 'SendOrderEmailAWSStepFunction',
                    OrderId: crossSellOrder.orderId,
                    CustomerId: this.appService.customerId,
                    QuestionnaireId: this.appService.questionnaireId,
                    ProcessId: this.appService.processId,
                    ProcessingOrderId: crossSellOrder.orderItem.processingOrder.processingOrderId
                };
                return this.emailNotificationService.sendEmailNotification(emailHandlerRequest);
            },
            post: emailHandlerResponse => {
                if (!environment.production) {
                    console.log('6. email sent. Cross-sell Order Id: ' +
                        crossSellOrder.orderId +
                        ' Message: ' +
                        emailHandlerResponse.Message);
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareCreateOrderContactPrimary(crossSellConfigId) {
        let crossSellOrder;
        return {
            name: 'prepareCreateOrderContactPrimary ' + this.constructor.name,
            pre: () => {
                if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
                    crossSellOrder = this.appService.tmsCrossSellOrderResponse;
                }
                else if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
                    crossSellOrder = this.appService.lwtCrossSellOrderResponse;
                }
                const createOrderContactRequest = {
                    orderContactId: null,
                    contactType: 'Primary',
                    firstName: this.appService.firstName,
                    lastName: this.appService.lastName,
                    addressLine1: this.questionnaireService.llc.businessAddress.address1,
                    addressLine2: this.questionnaireService.llc.businessAddress.address2,
                    city: this.questionnaireService.llc.businessAddress.city,
                    state: ConstantsService.getStateByAbbr(this.questionnaireService.llc.businessAddress.state),
                    county: this.questionnaireService.llc.businessAddress.county,
                    zipCode: this.questionnaireService.llc.businessAddress.zipCode,
                    emailAddresses: [{ emailAddress: this.appService.loginEmail.toString() }],
                    homePhone: this.questionnaireService.llc.contactPhone,
                    workPhone: '',
                    mobilePhone: '',
                    faxPhone: '',
                    country: null,
                    stateId: null,
                    dateCreated: null,
                    createdBy: this.appService.customerId.toString(),
                    dateLastModified: null,
                    lastModifiedBy: null,
                };
                if (createOrderContactRequest) {
                    return this.orderService.createOrderContact(crossSellOrder.orderId, createOrderContactRequest, this.appService.customerId);
                }
                else {
                    return of(null);
                }
            },
            post: response => {
                if (!environment.production) {
                    console.log('5. createBillOrder_CrossSell: createOrderContactPrimaryResponse  ' +
                        +crossSellOrder.orderId +
                        response);
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareCreateOrderContactShipping(crossSellConfigId) {
        let crossSellOrder;
        return {
            name: 'prepareCreateOrderContactShipping ' + this.constructor.name,
            pre: () => {
                if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
                    crossSellOrder = this.appService.tmsCrossSellOrderResponse;
                }
                else if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
                    crossSellOrder = this.appService.lwtCrossSellOrderResponse;
                }
                const createOrderContactRequest = {
                    orderContactId: null,
                    contactType: 'Shipping',
                    firstName: this.appService.firstName,
                    lastName: this.appService.lastName,
                    addressLine1: this.questionnaireService.llc.businessAddress.address1,
                    addressLine2: this.questionnaireService.llc.businessAddress.address2,
                    city: this.questionnaireService.llc.businessAddress.city,
                    state: ConstantsService.getStateByAbbr(this.questionnaireService.llc.businessAddress.state),
                    county: this.questionnaireService.llc.businessAddress.county,
                    zipCode: this.questionnaireService.llc.businessAddress.zipCode,
                    emailAddresses: [{ emailAddress: this.appService.loginEmail.toString() }],
                    homePhone: this.questionnaireService.llc.contactPhone,
                    workPhone: '',
                    mobilePhone: '',
                    faxPhone: '',
                    country: null,
                    stateId: null,
                    dateCreated: null,
                    createdBy: this.appService.customerId.toString(),
                    dateLastModified: null,
                    lastModifiedBy: null,
                };
                if (createOrderContactRequest) {
                    return this.orderService.createOrderContact(crossSellOrder.orderId, createOrderContactRequest, this.appService.customerId);
                }
                else {
                    return of(null);
                }
            },
            post: response => {
                if (!environment.production) {
                    console.log('5. createBillOrder_CrossSell: createOrderContactShippingResponse ' +
                        crossSellOrder.orderId +
                        response);
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareCreateOrderContactBilling(crossSellConfigId) {
        let crossSellOrder;
        return {
            name: 'prepareCreateOrderContactBilling ' + this.constructor.name,
            pre: () => {
                if (crossSellConfigId === ProductConfigurationIds.tmsCrosssell) {
                    crossSellOrder = this.appService.tmsCrossSellOrderResponse;
                }
                else if (crossSellConfigId === ProductConfigurationIds.lwtCrosssell) {
                    crossSellOrder = this.appService.lwtCrossSellOrderResponse;
                }
                const createOrderContactRequest = {
                    orderContactId: null,
                    contactType: 'Billing',
                    firstName: this.appService.firstName,
                    lastName: this.appService.lastName,
                    addressLine1: this.questionnaireService.llc.businessAddress.address1,
                    addressLine2: this.questionnaireService.llc.businessAddress.address2,
                    city: this.questionnaireService.llc.businessAddress.city,
                    state: ConstantsService.getStateByAbbr(this.questionnaireService.llc.businessAddress.state),
                    county: this.questionnaireService.llc.businessAddress.county,
                    zipCode: this.questionnaireService.llc.businessAddress.zipCode,
                    emailAddresses: [{ emailAddress: this.appService.loginEmail.toString() }],
                    homePhone: this.questionnaireService.llc.contactPhone,
                    workPhone: '',
                    mobilePhone: '',
                    faxPhone: '',
                    country: null,
                    stateId: null,
                    dateCreated: null,
                    createdBy: this.appService.customerId.toString(),
                    dateLastModified: null,
                    lastModifiedBy: null,
                };
                if (createOrderContactRequest) {
                    return this.orderService.createOrderContact(crossSellOrder.orderId, createOrderContactRequest, this.appService.customerId);
                }
                else {
                    return of(null);
                }
            },
            post: response => {
                if (!environment.production) {
                    console.log('5. createBillOrder_CrossSell: createOrderContactBillingResponse  ' +
                        crossSellOrder.orderId +
                        response);
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareUpdateQuestionnaireForTms() {
        return {
            name: 'prepareUpdateQuestionnaireForTMS ' + this.constructor.name,
            pre: () => {
                let fullName = this.questionnaireService.llc.entityName;
                if (this.questionnaireService.llc && this.questionnaireService.llc.entityNameDesignator) {
                    fullName += ' ' + this.questionnaireService.llc.entityNameDesignator;
                }
                fullName = (fullName) || 'Business Name';
                const userAnswerRequest = {
                    questionnaireFieldGroupAnswers: {
                        userOrderId: this.appService.tmsCrossSellOrderResponse.orderItem.processingOrder.processingOrderId,
                        questionnaireId: QuestionnaireId.TrademarkSearch,
                        fieldAnswers: [
                            {
                                fieldName: 'search_query',
                                fieldValue: fullName
                            },
                            {
                                fieldName: 'bExpressCheckout',
                                fieldValue: 'LLC_Crosssell_TMS_Federal_99'
                            },
                            {
                                fieldName: 'Foreign_translation',
                                fieldValue: 'Search with LLC Order'
                            },
                            {
                                fieldName: 'logo_MC',
                                fieldValue: 'No'
                            },
                            {
                                fieldName: 'list_goods_services',
                                fieldValue: this.questionnaireService.llc.businessPurpose
                            },
                            {
                                fieldName: 'class_number',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'contains_foreign_word',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_1',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_2',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_3',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_4',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_5',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_6',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_7',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_8',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_9',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_10',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_11',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_12',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_13',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_14',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_15',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_16',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_17',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_18',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_19',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_20',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_21',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_22',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_23',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_24',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_25',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_26',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_27',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_28',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_29',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_30',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_31',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_32',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_33',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_34',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_35',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_36',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_37',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_38',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_39',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_40',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_41',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_42',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_43',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_44',
                                fieldValue: ''
                            },
                            {
                                fieldName: 'class_45',
                                fieldValue: ''
                            }
                        ],
                        groupAnswers: []
                    }
                };
                return this.questionnaireAnswerService.saveAndGetMappedUserAnswers(userAnswerRequest, QuestionnaireId.TrademarkSearch, this.appService.customerId);
            },
            post: response => {
                if (!environment.production) {
                    console.log('3. update questionnaire for TMS');
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareUpdateQuestionnaireForLWT() {
        return {
            name: 'prepareUpdateQuestionnaireForLWT ' + this.constructor.name,
            pre: () => {
                const userAnswerRequest = {
                    questionnaireFieldGroupAnswers: {
                        userOrderId: this.appService.lwtCrossSellOrderResponse.orderItem.processingOrder.processingOrderId,
                        questionnaireId: QuestionnaireId.LastWillAndTestament,
                        fieldAnswers: [
                            {
                                fieldName: 'bGroupPlan',
                                fieldValue: 'Null'
                            },
                            {
                                fieldName: 'bExpressCheckout',
                                fieldValue: 'LLC_Crosssell_LWT_Basic_49'
                            }
                        ],
                        groupAnswers: []
                    }
                };
                return this.questionnaireAnswerService.saveAndGetMappedUserAnswers(userAnswerRequest, QuestionnaireId.LastWillAndTestament, this.appService.customerId);
            },
            post: response => {
                if (!environment.production) {
                    console.log('3. update questionnaire for LWT');
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareUpdateProcessingOrderForTms() {
        return {
            name: 'prepareUpdateProcessingOrderForTms ' + this.constructor.name,
            pre: () => {
                const updateProcessingOrderRequest = {
                    stateId: null,
                    isQuestionnaireCompleted: true,
                    postOption: null,
                    shippingMethodId: null,
                    lastPageVisited: 1000,
                    comment: '',
                    customerId: this.appService.customerId
                };
                return this.processingOrderService.updateProcessingOrder(this.appService.tmsCrossSellOrderResponse.orderItem.processingOrder
                    .processingOrderId, updateProcessingOrderRequest, this.appService.customerId);
            },
            post: response => {
                if (!environment.production) {
                    console.log('4. Mark processing order as completed');
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareTrackCrosssellOrderItems() {
        const that = this;
        return {
            name: 'prepareTrackCrosssellOrderItems ' + this.constructor.name,
            pre: () => {
                return of(null);
            },
            post: response => {
                that.trackCrosssellOrderItems();
                if (!environment.production) {
                    console.log('5. prepareTrackCrosssellOrderItems');
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    trackCrosssellOrderItems() {
        const win = this.trackingService.winRef.nativeWindow;
        if (win.oCMOrder !== undefined) {
            this.trackingService.ClearOAItems();
            win.oCMOrder.oaItems = win.oCMOrder.oaItems.concat(this.newSkuArray);
        }
    }
    preprareSaveAndContinue() {
        return {
            name: 'prepareSaveAndContinue ' + this.constructor.name,
            pre: () => {
                return of(this.eventService.saveAndContinue(PagePath.ExpressOffersPage));
            },
            post: response => { },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return of(null);
            }
        };
    }
    prepareTagOrderById_CrossSell(configId) {
        return {
            name: 'prepareTagOrderById_ExpressOrder ' + this.constructor.name,
            pre: () => {
                let crossSellOrder;
                let tagName;
                if (configId === ProductConfigurationIds.lwtCrosssell) {
                    crossSellOrder = this.appService.lwtCrossSellOrderResponse;
                    tagName = 'LLC_Crosssell_LWT_Basic_49';
                }
                if (configId === ProductConfigurationIds.tmsCrosssell) {
                    crossSellOrder = this.appService.tmsCrossSellOrderResponse;
                    tagName = 'LLC_Crosssell_TMS_Federal_99';
                }
                const tagOrderByIdRequest = {
                    tagType: TagType.system,
                    tag: tagName,
                    createdBy: this.appService.customerId.toString()
                };
                return this.taggingService.tagOrderById(crossSellOrder.orderId, tagOrderByIdRequest, this.appService.customerId);
            },
            post: tagOrderByIdResponse => {
                this.tagOrderByIdResponse = tagOrderByIdResponse;
            },
            error: (error) => {
                console.log(error.message);
                this.trackJS.track(ProductName.LLC, 'cross-sell.service', error);
                return (of(null));
            }
        };
    }
}
CrossSellService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CrossSellService_Factory() { return new CrossSellService(i0.ɵɵinject(i1.AppService), i0.ɵɵinject(i2.QueueService), i0.ɵɵinject(i3.OrderService), i0.ɵɵinject(i2.TrackJsErrorLogService), i0.ɵɵinject(i4.PaymentService), i0.ɵɵinject(i5.EmailNotificationService), i0.ɵɵinject(i6.QuestionnaireService), i0.ɵɵinject(i7.ProcessingOrderService), i0.ɵɵinject(i8.TrackingService), i0.ɵɵinject(i9.EventService), i0.ɵɵinject(i10.QuestionnaireAnswerService), i0.ɵɵinject(i11.TaggingService)); }, token: CrossSellService, providedIn: "root" });
